import { fetchWithAuth } from "../utils/authFetch";

/** Outcomes a logged call can have. Ids are persisted — keep them stable. */
export const CALL_OUTCOMES = [
  { id: "connected", label: "Connected" },
  { id: "no_answer", label: "No answer" },
  { id: "voicemail", label: "Left voicemail" },
  { id: "callback_requested", label: "Callback requested" },
];

export const callOutcomeLabel = (id) =>
  (CALL_OUTCOMES.find((o) => o.id === id) || CALL_OUTCOMES[0]).label;

/** Call logs for one person, newest first. */
export async function getCallLogs(personId) {
  const res = await fetchWithAuth(
    `/api/outreach/calls?personId=${encodeURIComponent(personId)}`,
  );
  if (!res.ok) throw new Error(`calls GET ${res.status}`);
  const data = await res.json();
  return Array.isArray(data?.items) ? data.items : [];
}

/** Log a call. `occurredAt` is an ISO string; omit for "now". */
export async function createCallLog(payload) {
  const res = await fetchWithAuth("/api/outreach/calls", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload || {}),
  });
  if (!res.ok) throw new Error(`calls POST ${res.status}`);
  return res.json();
}

export async function deleteCallLog(id) {
  const res = await fetchWithAuth(
    `/api/outreach/calls/${encodeURIComponent(id)}`,
    { method: "DELETE" },
  );
  if (!res.ok) throw new Error(`calls DELETE ${res.status}`);
  return res.json();
}
